import axios from 'axios';
import { appConstants } from './_constants/app.constants';

const TOKEN_KEY = 'tournamentApp_accessToken';

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshPromise = null;

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (!error.response || error.response.status !== 401 || original._authRetry) {
      return Promise.reject(error);
    }

    const url = original.url || '';
    if (
      url.includes('/api/auth/refresh') ||
      url.includes('/api/auth/login') ||
      url.includes('/api/auth/register') ||
      url.includes('/api/auth/forgot-password') ||
      url.includes('/api/auth/reset-password')
    ) {
      return Promise.reject(error);
    }

    const hadAccessToken = Boolean(localStorage.getItem(TOKEN_KEY));
    original._authRetry = true;

    try {
      if (!refreshPromise) {
        refreshPromise = axios
          .post(`${appConstants.API_URL}/api/auth/refresh`, {}, { withCredentials: true })
          .finally(() => {
            refreshPromise = null;
          });
      }
      const { data } = await refreshPromise;
      if (data?.accessToken) {
        localStorage.setItem(TOKEN_KEY, data.accessToken);
        original.headers.Authorization = `Bearer ${data.accessToken}`;
        return axios(original);
      }
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      const p = window.location.pathname;
      const tournamentHubOnly = /^\/tournamentactions\/[0-9a-f-]{36}$/i.test(p);
      // Sin sesión: listados públicos, landing, hub read-only del torneo. /viewer exige login (rol Viewer o staff).
      const publicPaths =
        p === '/' ||
        p.startsWith('/viewbracket') ||
        p.startsWith('/matches') ||
        p.startsWith('/viewgroups') ||
        p.startsWith('/documentacion') ||
        tournamentHubOnly;
      if (hadAccessToken && p !== '/login' && p !== '/register' && !publicPaths) {
        window.location.assign('/login');
      }
    }

    return Promise.reject(error);
  }
);

export function setAccessToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

export function getAccessToken() {
  return localStorage.getItem(TOKEN_KEY);
}
